export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: '极速秒开',
      desc: '采用先进的P2P加速技术，高清视频秒开不缓冲，观影体验流畅无比',
    },
    {
      icon: 'ri-4k-line',
      title: '高清画质',
      desc: '支持1080P和4K超清画质，每一帧都清晰细腻，带来影院级视觉享受',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端同步',
      desc: '支持电脑、手机、平板多终端同步观看，随时随地畅享精彩影片',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全无广告',
      desc: '纯净观影环境，无弹窗无恶意广告，保护您的设备安全和观影体验',
    },
    {
      icon: 'ri-global-line',
      title: '海量资源',
      desc: '收录超过10万部电影电视剧资源，涵盖全球热门影视内容，每日更新',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '智能推荐',
      desc: '基于AI算法的个性化推荐系统，精准推送您可能喜欢的影片内容',
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-[var(--font-heading)]">
            为什么选择6080新视觉影院
          </h2>
          <p className="text-sm text-foreground-500 mt-1">为您带来最佳的在线观影体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg p-5 md:p-6 flex items-start gap-4"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-accent-100 rounded-xl">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <div>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-1">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}